import React, { memo, useEffect, useState } from 'react';
import { RiDeleteBin6Line } from "react-icons/ri";
import axios from 'axios';
import { basePath, currencyList } from '../Constants/constant';
import Dropdown, { CurrencyDropdown } from '../Usables/Dropdown';
import InputField, { FileInput } from '../Usables/InputField';
import BasicButton from '../Usables/Buttons';
import { CancelIcon, EditIcon, SaveIcon } from '../Usables/IconButtons';
import CloseModal from '../Usables/CloseModal';

const JobPost = memo(({data, errors, disabled, loading, onChange, onAddQuestions, extraQuestions, 
    onSubmit, onChangeQuestions, onDeleteQuestion, handleSubmitUpdate, onEdit, onClose, onCancel, onlyView = false}) => {
    const handleChange = (e) => {
        onChange?.(e);
    };
    const handleSubmit = (e)=> {
        if(data?.id){
            handleSubmitUpdate?.(e);
        }else{
            onSubmit?.(e);
        }
    }
    const handleAddQuestions = (e)=> {
        onAddQuestions?.(e);
    }
    const handleChangeQuestions = (event, idx, check)=> {
        const syntheticEvent = {
        ...event,
        target: { ...event.target, name: event.target.name, value: check ? event.target.checked : event.target.value, index: idx },
      };
        onChangeQuestions?.(syntheticEvent);
    }
    const handleDelete = (e) => {
        onDeleteQuestion?.(e);
    };
    const [allCompany, setAllCompany] = useState([]);
    const [formData, setFormData] = useState({
        company: "",
        position: "",
        location: "",
        min_experience: "",
        max_experience: "",
        minCtc: "",
        maxCtc: "",
        no_of_positions: "",
        positon_industry: "",
        gender_pref: "",
        qualification: "",
        description: ""
    });
    const genderOptions = [
        {value: "Male", label: "Male"},
        {value: "Female", label: "Female"},
        {value: "No preference", label: "No preference"},
    ]
    const getCompany = async () => {
        try { 
            const response = await axios.get(`${basePath}/getcompany`);
            // console.log("company==>>", response.data);
            const list = response?.data?.map((item)=>{
                return {value: item?.id, label: item?.company_name}
            })
            setAllCompany(list);
        } catch (error) {
            console.log(error);
        }

    }
    useEffect(() => {
        getCompany();
    }, []);

    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                {!onlyView && 
                    (onEdit && disabled ? 
                    <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                    <>
                        {data?.id && (<CancelIcon disabled={loading} className=" top-3 left-8" onClick={onCancel} />)}
                        <SaveIcon disabled={loading} loading={loading} btnName="Submit" className={`top-3 ${data?.id ? "left-36" : "left-10"}`} onClick={handleSubmit} />
                    </>)}
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Job Post</h1>
                <div className='w-full  max-h-[75dvh] overflow-scroll px-2'>
                    <section className=' grid md:grid-cols-2 grid-cols-1 gap-3 p-2 mb-3'>
                        <Dropdown id="company" name="company"
                        onChange={handleChange}
                        onCancel={handleChange}
                        label="Company:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`Select Company`}
                        value={data?.company}
                        options={allCompany}
                        required={true}
                        search={true}
                        error={errors?.company}
                        disabled={data?.id ? true : disabled}
                        />
                        <InputField
                        id="position"
                        name="position"
                        type="text"
                        label="Position:"
                        placeholder="Position"
                        value={data?.position}
                        onChange={handleChange}
                        error={errors?.position}
                        disabled={disabled}
                        required={true}
                        />
                        <InputField
                        id="location"
                        name="location"
                        type="text"
                        label="Location:"
                        placeholder="Location"
                        value={data?.location}
                        onChange={handleChange}
                        error={errors?.location}
                        disabled={disabled}
                        required={true}
                        />
                        <div className=' grid grid-cols-2 gap-3'>                            
                            <InputField
                            id="min_experience"
                            name="min_experience"
                            type="text"
                            label="Min Experience:"
                            placeholder="Min Experience"
                            value={data?.min_experience}
                            onChange={handleChange}
                            error={errors?.min_experience}
                            disabled={disabled}
                            required={true}
                            />
                            <InputField
                            id="max_experience"
                            name="max_experience"
                            type="text"
                            label="Max Experience:"
                            placeholder="Max Experience"
                            value={data?.max_experience}
                            onChange={handleChange}
                            error={errors?.max_experience}
                            disabled={disabled}
                            required={true}
                            />
                        </div>
                        <div className=' grid grid-cols-[1fr_2fr_2fr] gap-3'>
                            <CurrencyDropdown id="currency_code" name="currency_code" label="Currency:"
                            onChange={handleChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled}
                            placeholder={`Select`}
                            error={errors?.currency_code}
                            textColor={disabled && "text-blue-700"}
                            value={data?.currency_code}
                            options={currencyList}
                            required={true}
                            />
                            <InputField
                            id="minCtc"
                            name="minCtc"
                            type="text"
                            label="MinCTC (LPA):"
                            placeholder="Min CTC"
                            value={data?.minCtc}
                            onChange={handleChange}
                            error={errors?.minCtc}
                            disabled={disabled}
                            required={true}
                            />
                            <InputField
                            id="maxCtc"
                            name="maxCtc"
                            type="text"
                            label="MaxCTC (LPA):"
                            placeholder="Max CTC"
                            value={data?.maxCtc}
                            onChange={handleChange}
                            error={errors?.maxCtc}
                            disabled={disabled}
                            required={true}
                            />
                        </div>
                        <div className=' grid grid-cols-2 gap-3'>
                        <InputField
                            id="no_of_positions"
                            name="no_of_positions"
                            type="text"
                            label="No. of positions:"
                            placeholder="Total Positions"
                            value={data?.no_of_positions}
                            onChange={handleChange}
                            error={errors?.no_of_positions}
                            disabled={disabled}
                            required={true}
                        />
                        <InputField
                            id="positon_industry"
                            name="positon_industry"
                            type="text"
                            label="Industry:"
                            placeholder="Industry"
                            value={data?.positon_industry}
                            onChange={handleChange}
                            error={errors?.positon_industry}
                            disabled={disabled}
                            required={true}
                        />
                        </div>
                        <Dropdown id="gender_pref" name="gender_pref"
                        onChange={handleChange}
                        onCancel={handleChange}
                        label="Gender Preference:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`Select Gender`}
                        value={data?.gender_pref}
                        options={genderOptions}
                        error={errors?.gender_pref}
                        disabled={disabled}
                        required={true}
                        />
                        <InputField
                        id="qualification"
                        name="qualification"
                        type="text"
                        label="Qualification:"
                        placeholder="Qualification"
                        value={data?.qualification}
                        onChange={handleChange}
                        error={errors?.qualification}
                        disabled={disabled}
                        required={true}
                        />
                            <div className=' grid grid-cols-2 gap-3'>
                            <InputField
                            id="min_age"
                            name="min_age"
                            type="text"
                            label="Min Age:"
                            placeholder="Min age"
                            value={data?.min_age}
                            onChange={handleChange}
                            error={errors?.min_age}
                            disabled={disabled}
                            />
                            <InputField
                            id="max_age"
                            name="max_age"
                            type="text"
                            label="Max Age:"
                            placeholder="Max age"
                            value={data?.max_age}
                            onChange={handleChange}
                            error={errors?.max_age}
                            disabled={disabled}
                            />
                        </div>
                        <FileInput
                        name="jd_upload"
                        accept=".pdf"
                        label="Upload Job Description:"
                        placeholder="Upload JD"
                        disabled={disabled}
                        value={data?.jd_upload}
                        onSelect={handleChange} 
                        error={errors?.jd_upload}
                        />
                    </section>
                    {extraQuestions?.length > 0 && (<hr />)}
                    <div className='grid grid-cols-1 gap-3 mt-3'>
                        {extraQuestions?.map((item, idx)=>{
                            return (
                                <div className=' w-full'>
                                    <div className=' flex justify-between items-center mb-3'>
                                        <h1 className=' text-left'>{`Question ${idx+1}.`}</h1>
                                        <div className=' flex gap-2 items-center'>
                                            <input id={`required`} name={`required`} disabled={disabled} onChange={e => handleChangeQuestions(e,idx,"check")} checked={item.required} type="checkbox" />
                                            <label htmlFor={`required`}>Required</label>
                                        </div>
                                    </div>
                                    <div className=' flex items-center gap-3'>
                                        <InputField
                                        id={`question`}
                                        name={`question`}
                                        type={item?.type}
                                        className="flex-1"
                                        // label="Qualification:"
                                        placeholder="Write Question"
                                        value={item?.question}
                                        onChange={e => handleChangeQuestions(e,idx)}
                                        // error={errors?.qualification}
                                        disabled={disabled}
                                        />
                                        {!disabled && (
                                            <div data-index={idx} onClick={handleDelete} className='border border-gray-300 bg-white hover:bg-gray-100 rounded-lg p-2.5 cursor-pointer'>
                                                <RiDeleteBin6Line className=' text-red-600 text-xl cursor-pointer hover:text-red-800' />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })}     
                    </div>
                    {!disabled && (
                        <div className=' w-full flex items-center justify-between mt-2 mb-4'>
                            <BasicButton onClick={handleAddQuestions} buttonName='Add Question' className=' bg-blue-700 text-white text-nowrap' shadow={true}
                            disabled={loading} 
                            rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-blue-800" /> 
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
})

export default JobPost;